import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'
import { checkText } from 'smile2emoji'
import DOMPurify from "dompurify";
import RetryAfter from './RetryAfter';

import './ChatMessageInput.scss';

export const ChatMessageInput = ({ onSendMessage, clearInput, placeHolder }: { onSendMessage: (msg: string) => any, clearInput: boolean, placeHolder?: string }) => {
    const inputTextRef = useRef(null);
    const [chatInput, setChatInput] = useState('');
    const [isEmojiVisible, setEmojiVisible] = useState(false);

    const handleInputChange = useCallback(
        event => {
            // sanitize the input a little
            const text = event.target.value;
            const withEmoji = checkText(text);
            setChatInput(DOMPurify.sanitize(withEmoji.substring(0, 500)));
        }, [setChatInput]);

    const inputKeyPressed = useCallback((e) => {
        if (e.code === 'Enter') {
            onEnter();
        }
    }, [chatInput]);

    const addEmoji = useCallback((e) => {
        // console.log('add emoji', e);
        setChatInput(DOMPurify.sanitize((chatInput + ' ' + e.native).substring(0, 500)));
        setEmojiVisible(false);
        if (inputTextRef && inputTextRef.current) {
            inputTextRef.current.focus();
        }
    }, [chatInput]);

    const onEnter = useCallback(() => {
        onSendMessage(chatInput);
        setChatInput('');
    }, [chatInput]);

    useEffect(() => setChatInput(''), [clearInput]);

    return <div className='hostchattool-footer'>
        <div className='input-rectangle'>

            <RetryAfter>
                <input id="hostchattool-input" type="text" placeholder={placeHolder || 'Type your message'} className="hostchattool-input" value={chatInput} onChange={handleInputChange} onKeyPress={e => inputKeyPressed(e)} ref={inputTextRef} />
                <div className='emoji-selector' onClick={() => setEmojiVisible(!isEmojiVisible)}></div>
            </RetryAfter>

        </div>
        {/* may be one day ;)   delete all visible chats
            <div className="delete-history" onClick={() => setShowDeleteHistoryDialog(true)}></div>
        */}


        {isEmojiVisible &&
            <div className='emoji-picker'>
                <Picker onSelect={addEmoji} native={true} showPreview={true} showSkinTones={true} emojiTooltip={true} />
            </div>
        }
    </div>
};